var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeProject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6087 8.211C18.575 9.22772 18.575 10.7724 17.6087 11.7892C15.9788 13.504 13.1797 15.8334 10.0001 15.8334C6.82049 15.8334 4.02133 13.504 2.3915 11.7892C1.42516 10.7724 1.42516 9.22772 2.3915 8.211C4.02132 6.49619 6.82048 4.16675 10.0001 4.16675C13.1797 4.16675 15.9788 6.49619 17.6087 8.211Z",
    stroke: "#2247C0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 10.0001C12.5001 11.3808 11.3808 12.5001 10.0001 12.5001C8.61937 12.5001 7.50008 11.3808 7.50008 10.0001C7.50008 8.61937 8.61937 7.50008 10.0001 7.50008C11.3808 7.50008 12.5001 8.61937 12.5001 10.0001Z",
    stroke: "#2247C0",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeProject);
export default __webpack_public_path__ + "static/media/eye-project.77ac150a05a67f507edb185fa447aa52.svg";
export { ForwardRef as ReactComponent };